import { Link } from "react-router-dom";

/**
 * `PublicTrustFooter` — the single source of truth for the public-facing
 * trust footer. Rendered on Landing, Privacy Policy and Terms of Use so
 * soft-launch visitors see the same helper disclaimer, the same two
 * policy links, and the same corporate line no matter where they land.
 *
 * Layout — kept compact on mobile, exactly three stacked lines:
 *   1. Made in Australia · Helper disclaimer
 *   2. Privacy Policy · Terms of Use
 *   3. © 2026 BuildIntel AI. All rights reserved. ABN 82 319 960 400
 *
 * DO NOT reword the disclaimer without legal review — the wording tracks
 * the language the founder cleared with their accountant. Australian
 * English throughout ("organise", "recognise"). No badges (Soft launch,
 * ATO chips, trade chips) allowed here — this block is trust-only.
 *
 * Intentionally NOT used inside authed screens (Capture, Ledger, Tax AI,
 * etc.) — those keep the smaller `BrandFooterLine` so the work surfaces
 * stay uncluttered.
 */
export default function PublicTrustFooter({ testId = "public-trust-footer" }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col gap-3"
    >
      <p
        data-testid={`${testId}-disclaimer`}
        className="text-xs text-white/60 leading-relaxed font-medium"
      >
        <span className="text-white/80">Made in Australia</span>
        <span className="text-white/25 mx-1.5" aria-hidden="true">·</span>
        Helper tool only — not a registered tax agent. Confirm figures with your accountant before lodgement.
      </p>
      <div className="flex items-center gap-3 text-xs" data-testid={`${testId}-policies`}>
        <Link
          to="/privacy"
          data-testid={`${testId}-privacy`}
          className="text-white/70 hover:text-white transition-colors underline-offset-4 hover:underline"
        >
          Privacy Policy
        </Link>
        <span className="text-white/25" aria-hidden="true">·</span>
        <Link
          to="/terms"
          data-testid={`${testId}-terms`}
          className="text-white/70 hover:text-white transition-colors underline-offset-4 hover:underline"
        >
          Terms of Use
        </Link>
      </div>
      <div
        data-testid={`${testId}-copyright`}
        className="text-xs text-white/45"
      >
        &copy; 2026 BuildIntel AI. All rights reserved. ABN 82 319 960 400
      </div>
    </div>
  );
}
